/* eslint-disable */

import 'App.css'
import { Box, Container, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import IntarsiaCanvas from '../components/IntarsiaCanvas'
import { useSearchParams } from 'react-router-dom'

import { useState } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
} from "react-router-dom"

function CreateIntarsia() {
  const [searchParams] = useSearchParams()
  const craft = searchParams.get('craft') as 'knitting' | 'crochet' | 'cross_stitch' | null
  const crochetStitchType = searchParams.get('crochet_stitch_type') as 'sc' | 'hdc' | 'dc' | null

  const getHeaderText = () => {
    if (!craft) return 'Create Color Chart'
    
    const craftLabels: Record<string, string> = {
      knitting: 'Knitting',
      crochet: 'Crochet',
      cross_stitch: 'Cross Stitch'
    }
    
    const stitchLabels: Record<string, string> = {
      sc: 'Single Crochet',
      hdc: 'Half Double Crochet',
      dc: 'Double Crochet'
    }
    
    if (craft === 'crochet' && crochetStitchType) {
      return `Create ${stitchLabels[crochetStitchType]} Chart`
    }
    
    return `Create ${craftLabels[craft]} Chart`
  }

  return (
    <>
      <Container className="App">
        <Box sx={{ mb: 1, mt: 2, px: 2, textAlign: 'left' }}>
          <Typography variant="h6" component="h1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
            {getHeaderText()}
          </Typography>
        </Box>
        <Box alignSelf='center'>
          <IntarsiaCanvas />
        </Box>
      </Container>
    </>
  );
}

export default CreateIntarsia
